/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseTestDto } from '../../models/response-test-dto';
import { UpdateTestDto } from '../../models/update-test-dto';

export interface TestsControllerUpdate$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Test ID
 */
  id: string;
      body: UpdateTestDto
}

export function testsControllerUpdate(http: HttpClient, rootUrl: string, params: TestsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
  const rb = new RequestBuilder(rootUrl, testsControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseTestDto>;
    })
  );
}

testsControllerUpdate.PATH = '/thalea-pathways/tests/{tenant}/{id}';
